const stringToNumber = (str) => {
    if(typeof str === 'string' && str.length > 0){
        return +str
    } else {
        return str
    }
}

export default stringToNumber